import { render, staticRenderFns } from "./SwitchButton.vue?vue&type=template&id=736f5cb7&scoped=true"
import script from "./SwitchButton.vue?vue&type=script&lang=js"
export * from "./SwitchButton.vue?vue&type=script&lang=js"
import style0 from "./SwitchButton.vue?vue&type=style&index=0&id=736f5cb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736f5cb7",
  null
  
)

export default component.exports